export {PictureInPicture} from './picture-in-picture';



// WEBPACK FOOTER //
// ./components/picture-in-picture/index.js


// WEBPACK FOOTER //
// ui/components/picture-in-picture/index.js